var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcHealth(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.75 26H17.6875L20.0625 22.4375L24.8125 29.5625L27.1875 26H30.75",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1711 21.25C11.1563 21.057 11.1562 20.8492 11.1562 20.6563C11.1562 18.8719 11.7745 17.1426 12.9058 15.7626C14.037 14.3827 15.6115 13.4373 17.3612 13.0874C19.111 12.7374 20.9279 13.0045 22.5029 13.8432C24.0779 14.6819 25.3137 16.0404 26 17.6875V17.6875C26.6863 16.0404 27.9221 14.6819 29.4971 13.8432C31.0721 13.0045 32.889 12.7374 34.6388 13.0874C36.3885 13.4373 37.963 14.3827 39.0942 15.7626C40.2255 17.1426 40.8438 18.8719 40.8438 20.6563C40.8438 30.75 26 39.0625 26 39.0625C26 39.0625 20.0773 35.7375 15.7133 30.75",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHealth);
export default __webpack_public_path__ + "static/media/ic_health.109c20fe25d38aaabc839653e497d573.svg";
export { ForwardRef as ReactComponent };